(function () {
  if (window.flagwixCollectionFiltersBound) return;

  window.flagwixCollectionFiltersBound = true;

  document.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest(
        '.template-collection #shopify-section-facets #t4s-filter-hidden [data-sidebar-links] a:not([data-not-a-filter])'
      );

      if (
        !link ||
        event.button !== 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey
      ) {
        return;
      }

      var ajaxContainer = document.querySelector(
        '.template-collection .t4s-section-main [data-ntajax-container]'
      );
      var facets = ajaxContainer && ajaxContainer.Facets;
      var themeQuery = window.jQuery_T4NT;

      if (!facets || !themeQuery) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      var filterLink = themeQuery(link);
      facets.closeDrawer(filterLink);
      facets.filterActionLink(filterLink);
    },
    true
  );
})();
